import React, { FC } from "react";
import { useQuery } from "react-query";
import { IWizardStepContent } from "../../../../wizard/types";
import { QUERY_KEYS } from "../../../../../constants";
import useBranchQueries from "../../../../school/hooks/useBranchQueries";
import { parseToCreateCoursePreview } from "../../../helpers/parseToCreateCoursePreview";
import { ViewCourse } from "../../components";

const Content: FC<IWizardStepContent> = ({ values }) => {
  const { branches: branchesQueryKey } = QUERY_KEYS;
  const { fetchAll: fetchAllBranches } = useBranchQueries();
  const { data: branches } = useQuery<any>(branchesQueryKey, () =>
    fetchAllBranches({ schoolId: values.schoolId }),
  );

  if (!branches) {
    return null;
  }

  const previewData = parseToCreateCoursePreview({
    courseRawData: values,
    branches: branches.data,
  });

  return <ViewCourse {...previewData} />;
};

export default Content;
